.header {
    padding-bottom: 15px;
    background: url(./assets/images/theme/header_bar.jpg) bottom left repeat-x;
}

.h1 {
    min-width: 900px;
    height: 116px;
    background: url(./assets/images/theme/pupil_photo.jpg) top right no-repeat;
    margin: 0;
}

.img {
    width: 580px;
    height: 116px;
}
